import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { Confluence } from '../interfaces';
import { deleteConfluenceArticle } from '../api';

function useDeleteArticle(article: Confluence.IArticle | null, onDelete?: (article: Confluence.IArticle) => void) {
  const { enqueueSnackbar } = useSnackbar();

  const [{ error, loading }, setArticle] = useState<{
    loading: boolean;
    error: string | null;
  }>({ loading: false, error: null });

  async function handleDeleteArticle() {
    if (!article?.id) return;

    try {
      setArticle((prevState) => ({ ...prevState, loading: true }));

      await deleteConfluenceArticle(article.id);

      if (onDelete) onDelete(article);
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      enqueueSnackbar(message, { variant: 'error' });
      setArticle((prevState) => ({ ...prevState, error: message }));
    } finally {
      setArticle((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { error, loading, handleDeleteArticle };
}

export default useDeleteArticle;
